import { clamp } from 'utils/misc';

export const supportedDenominations =
    [1, 2, 4, 5, 10, 25, 50, 75, 100, 200, 400, 500, 1000, 2500, 5000, 10000];

export function adjustedIndex(index, min, max) {
    const denom = supportedDenominations[index];
    const fixed = clamp(denom, min, max);

    return supportedDenominations.indexOf(fixed);
}
